import React from 'react';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDBox, FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { Layout } from './Layout';

export const ReferralPageInfoBoxes = ({ collection }) => {
  return (
    <FDBox paddingY={2}>
      <FDPaper appearance={'elevated'}>
        <FDStack direction="column" spacing={5} padding={4}>
          <MetaControlField attr={'howToTitle'} />
          <FDStack direction={'column'} spacing={4}>
            <MetaCollectionRenderer
              collection={collection}
              layout={Layout}
            />
          </FDStack>
        </FDStack>
      </FDPaper>
    </FDBox>
  );
};

ReferralPageInfoBoxes.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
